import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Chart, registerables } from 'chart.js';
import { PaisService } from 'src/app/generales/services/pais.service';
import { AdminServiceService } from '../../service/admin-service.service';

@Component({
  selector: 'app-productt-chart',
  templateUrl: './productt-chart.component.html',
  styleUrls: ['./productt-chart.component.scss'],
})
export class ProducttChartComponent implements OnInit {
  @ViewChild('lineCanvas') private lineCanvas: ElementRef;
  @Input() product: any = undefined;
  public lineChart: Chart;
  public year = (new Date()).getFullYear();
  private data = undefined;
  
  constructor(
    public modalController: ModalController,
    private paisSv: PaisService,
    private adminSv: AdminServiceService
  ) { 
    Chart.register(...registerables);
  }

  ngOnInit() {
  }

  async ngAfterViewInit() {
    this.getStats();
  }

  async getStats(){
    const res = await this.adminSv.getStats('showProduct', null, this.product.id, this.year);
    this.data = res;
    this.lineChartMethod();
  }
  
  lineChartMethod() {
    const labels = this.paisSv.labels;
    const datasets = [];
    for (const key in this.data) {
      if (Object.prototype.hasOwnProperty.call(this.data, key)) {
        let label = '';
        if(key === 'likes'){
          label = 'Me gustas'
        }else if(key === 'sales'){
          label = 'Ventas'
        }else if(key === 'saves'){
          label = 'Guardados'
        }else if(key === 'show'){
          label = 'Vistas'
        }
        const elements: any[] = this.data[key];
        const data = [];
        elements.map(element => {
          const month = Number(element.gruopYearMonth.split('-')[1] - 1);
          data[month] = element.total;
        })
        const dataset = {
          label,
          data
        }
        datasets.push(dataset)
      }
    }
    if(this.lineChart){
      this.lineChart.data = {
        labels: labels.map(x => x.name),
        datasets
      }
      this.lineChart.update();
      return true;
    }

    this.lineChart = new Chart(this.lineCanvas.nativeElement, {
      type: 'line',
      data: {
        labels: labels.map(x => x.name),
        datasets
      }
    });

  }

  async changeYear(direction){
    direction ? this.year++ : this.year--;
    await this.getStats();
  }
}
